import {http} from './config/config-relation-register'
export default{
    listar:(token)=>{
        return http.get(`ingrediente-ativos`,{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, item)=>{
        return http.post('ingrediente-ativos',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('ingrediente-ativos/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('ingrediente-ativos/'+item.id_ingrediente_ativo,item,{
            headers:{
                'Authorization':token
            }
        })
    }
}